var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M1.38288 5.84652L18.6212 5.84652L18.6212 5.09625L1.49016 5.09625L5.83615 0.75026L5.30563 0.219739L0.530863 4.99451L0.530777 4.99442L0.428948 5.09625L0.428649 5.09625L0.428649 5.09655L0.000256261 5.52494L5.30547 10.8302L5.83599 10.2996L1.38288 5.84652Z","fill":"#221D23"}));
}

ArrowLeft.defaultProps = {"width":"19","height":"11","viewBox":"0 0 19 11","fill":"none"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
